<div class="lista-vazia">
  <nb-icon [icon]="icone" class="lista-vazia-icone" aria-hidden="true"></nb-icon>

  <p class="lista-vazia-texto">{{ filtrado ? mensagemFiltrado : mensagem }}</p>

  <button
    *ngIf="filtrado"
    nbButton
    ghost
    status="primary"
    size="small"
    type="button"
    (click)="verTodos.emit()"
  >
    Ver todos
  </button>

  <button
    *ngIf="!filtrado && acaoCriarRotulo"
    nbButton
    status="primary"
    size="small"
    type="button"
    (click)="criar.emit()"
  >
    {{ acaoCriarRotulo }}
  </button>
</div>
